module.exports = ".dvFileMargin {\n  margin-top: 30px; }\n"